import type { LucideIcon } from 'lucide-react';
import { BookCopy, BookUser, Calendar, Wallet } from 'lucide-react';

export type NavItem = {
  label: string;
  to?: string; // internal route
  href?: string; // external link
  external?: boolean; // show external icon and open in new tab
  badge?: number | string;
  cta?: boolean; // render as primary CTA button
  icon?: LucideIcon;
  children?: NavItem[];
};

export type NavGroup = {
  title: string;
  items: NavItem[];
};

export const navGroups: NavGroup[] = [
  {
    title: '',
    items: [
      { label: 'Crear evento', to: '/panel/eventos/crear', cta: true },
      { label: 'Eventos', to: '/panel/eventos/listado', icon: BookCopy },
      { label: 'Calendario', to: '/panel/calendario', icon: Calendar },
    ],
  },
  {
    title: 'Administración',
    items: [
      { label: 'Clientes', to: '/panel/clientes', icon: BookUser },
      { label: 'Pagos', to: '/panel/pagos', icon: Wallet },
    ],
  },
  {
    title: 'Sistema',
    items: [
      { label: 'Website', href: 'http://bloomkeep.site', external: true },
      { label: 'LogRocket', href: 'https://app.logrocket.com/ugucxk/bloomkeep-app', external: true },
      { label: 'Sentry', href: 'https://bloomkeep-inc.sentry.io/auth/login/bloomkeep-inc', external: true },
      { label: 'Bunny', href: 'https://dash.bunny.net/', external: true },
      { label: 'Cloudinary', href: 'https://console.cloudinary.com/app/c-46234c47a7d866ff3b3f14e838b06d/assets/media_library/', external: true },
    ],
  },
];

export function findBreadcrumb(groups: NavGroup[], pathname: string) {
  const stack: { label: string; to?: string }[] = [];

  for (const group of groups) {
    const res = dfs(group.items, pathname, []);
    if (res) {
      stack.push({ label: 'Panel', to: '/panel' });
      // Only include the group title when it is non-empty (avoid empty breadcrumb items)
      const groupTitle = (group.title || '').trim();
      if (res.length === 1 && groupTitle) {
        stack.push({ label: groupTitle });
      }
      for (const item of res) stack.push(item);
      return stack;
    }
  }
  return [{ label: 'Panel', to: '/panel' }];
}

function dfs(items: NavItem[], pathname: string, acc: { label: string; to?: string }[]): { label: string; to?: string }[] | null {
  for (const item of items) {
    const nextAcc = item.to ? [...acc, { label: item.label, to: item.to }] : [...acc, { label: item.label }];
    if (item.to && pathname.startsWith(item.to)) return nextAcc;
    if (item.children) {
      const res = dfs(item.children, pathname, nextAcc);
      if (res) return res;
    }
  }
  return null;
}
